module.exports = require("./lib/dom-scroll-into-view");